module.exports = "/_next/static/images/mining-a930d5a2e95b2be7d0784d37a41cf84e.png.webp";